<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 75vh;">
    <p class="Titulo">Consulta - Componente</p>
    <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;"
      (click)="consultarComponenteConsulta()">
      <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
    </button>
    <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
    <div *ngIf="showGrillaConsulta">
      <!-- <angular-slickgrid gridId="gridComponenteConsulta" [columnDefinitions]="columnDefinitionsComponenteConsulta"
        [gridOptions]="gridOptionsComponenteConsulta" [dataset]="datasetComponenteConsulta" gridHeight="380"
        gridWidth="100%" (onAngularGridCreated)="angularGridReadyComponenteConsulta($event)">
      </angular-slickgrid> -->
      <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetComponenteConsulta"
            [columnDefs]="columnDefinitionsComponenteConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>

    </div>
    <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz"
      [hidden]="!showGrillaConsulta" [disabled]="!showGrillaConsulta" (click)="exportToExcelComponente()">
      <nb-icon icon="save-outline"></nb-icon>Exportar
    </button>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive
    style="height: 75vh;">
    <div class="row">
      <div class="col-4 float-left">
        <p class="Titulo">Alta Componente</p>
        <p style="margin-top: 10px; align-items: center; justify-content: center">
          <!-- <nb-checkbox [(ngModel)]="tieneCuadranteAlta" name="cuadranteAlta" style="margin-right: 50px;">Cuadrante</nb-checkbox> -->
          <nb-checkbox [(ngModel)]="tieneZonaAlta" name="zonaAlta">Zona-Cuadrante</nb-checkbox>
        </p>
        <div>
          <p-dropdown required class="limited-selector" id="inputZonaCuadranteAlta"
            placeholder="Seleccionar Zona Cuadrante" [style]="{'width':'100%'}" [options]="zonaCuadrante"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
            [(ngModel)]="zonaCuadranteSeleccionadoAlta" [disabled]="!tieneZonaAlta">
          </p-dropdown>
        </div>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción</mat-label>
            <input matInput #message1 maxlength="80" [(ngModel)]="descripcionComponente" name="descripcion">
            <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción Breve</mat-label>
            <input matInput #message2 maxlength="80" [(ngModel)]="descripcionBreve" name="breve">
            <mat-hint align="end">{{message2.value.length}} / 80</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Código Externo</mat-label>
            <input matInput #message3 maxlength="40" [(ngModel)]="codigoExterno" name="codigo">
            <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
          <button nbButton size="tiny" class="buttontz" (click)="altaComponente()">Guardar</button>
        </p>

      </div>
      <div>
        <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarComponente()">
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner class="col-6" *ngIf="showSpinner"></app-spinner>
      <div *ngIf="showGrilla" class="col-6">
        <!-- <angular-slickgrid gridId="gridComponente" [columnDefinitions]="columnDefinitionsComponente"
          [gridOptions]="gridOptionsComponente" [dataset]="datasetComponente" gridHeight="380"
          (onAngularGridCreated)="angularGridReadyComponente($event)">
        </angular-slickgrid> -->
        <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetComponente"
            [columnDefs]="columnDefinitionsComponente"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
      </div>
    </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive
    style="height: 75vh;">
    <p class="Titulo">Modificar Componente</p>
    <div class="row">
      <div class="col-4 float-left">
        <div>
          <div>
            <p-dropdown required class="limited-selector" id="inputTipo" placeholder="Seleccionar Componente"
              [style]="{'width':'100%','margin-top':'10px'}" [options]="componente" [(ngModel)]="ComponenteProcesado"
              (onChange)="obtenerDescripcionDropdown(ComponenteProcesado)" [virtualScroll]="true" [itemSize]="31"
              [filter]="true"
              [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
            </p-dropdown>
          </div>

        </div>
        <div>
          <div style="margin-top: 20px; align-items: center; justify-content: center">
            <!-- <nb-checkbox [(ngModel)]="tieneCuadranteModificar" name="cuadrante" style="margin-right: 50px;">Cuadrante</nb-checkbox> -->
            <nb-checkbox [(ngModel)]="tieneZonaModificar" name="zona">Zona-Cuadrante</nb-checkbox>
          </div>
          <div>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion</mat-label>
              <input matInput #message4 maxlength="80" [(ngModel)]="descripcionComponenteEditar"
                name="descripcionComponenteEditar">
              <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion Breve</mat-label>
              <input matInput #message5 maxlength="80" [(ngModel)]="descripcionBreveEditar"
                name="descripcionBreveEditar">
              <mat-hint align="end">{{message5.value.length}} / 80</mat-hint>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Código Externo</mat-label>
              <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditar" name="codigoExternoEditar">
              <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
            </mat-form-field>
          </div>
          <div>
            <!-- <p-dropdown required class="limited-selector" id="inputZonaCuadrante"
              placeholder="Seleccionar Zona Cuadrante" [style]="{'width':'100%','margin-top':'10px'}"
              [options]="zonaCuadrante" [virtualScroll]="true" [itemSize]="31" 
              [filter]="true"
              [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
              [(ngModel)]="zonaCuadranteSeleccionado" [disabled]="!tieneZonaModificar">
            </p-dropdown>
           -->
          <p-dropdown
          required
          class="limited-selector"
          id="inputZonaCuadrante"
          placeholder="Seleccionar Zona Cuadrante"
          [style]="{'width':'100%','margin-top':'10px'}"
          [options]="zonaCuadrante"
          [virtualScroll]="true"
          [itemSize]="31"
          [filter]="true"
          [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
          [(ngModel)]="zonaCuadranteSeleccionado"
          [disabled]="!tieneZonaModificar"
          [panelStyle]="{'bottom':'100%','top':'auto'}"
        >
        </p-dropdown>
            <!-- [appendTo]="'body'" -->
        </div>
          <br>
          <p>
            <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar
            </nb-checkbox>
          </p>
          <p>
            <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
            <button *ngIf="!showSpinnerModificar" nbButton size="tiny" class="buttontz"
              (click)="modificarComponente()">Modificar</button>
          </p>
        </div>
      </div>
      <div class="col-6 float-rifht">
        <app-spinner class="col-6" *ngIf="showSpinnerModificarGrilla"></app-spinner>
      <div *ngIf="showGrillaModificar">
        <!-- <angular-slickgrid gridId="gridComponenteModificar" [columnDefinitions]="columnDefinitionsComponenteModificar"
          [gridOptions]="gridOptionsComponenteModificar" [dataset]="datasetComponenteModificar" gridHeight="380"
          (onAngularGridCreated)="angularGridReadyComponenteModificar($event)">
        </angular-slickgrid> -->
        <ag-grid-angular
            #grilla3
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetComponenteModificar"
            [columnDefs]="columnDefinitionsComponenteModificar"
            (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true"/>
      </div>
      </div>
    </div>
  </nb-tab>
</nb-tabset>